import script from "./ProjectPlanEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectPlanEditor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__